namespace TabAurous.Common {
    export interface OpeningStockResponse extends Serenity.ServiceResponse {
        Products?: Inventory.OpeningStockItemsRow[];
        Issues?: Issue[];
    }
}
